import {
  type ContextType,
  type Dispatch,
  type FC,
  type PropsWithChildren,
  type SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

type RevisionListenerStatus =
  | 'ready'
  | 'listening'
  | 'suggesting'
  | 'suggested';

const Context = createContext<
  | {
      revisionListenerStatus: RevisionListenerStatus;
      setRevisionListenerStatus: Dispatch<
        SetStateAction<RevisionListenerStatus>
      >;
    }
  | undefined
>(undefined);

const _useContext = (): NonNullable<ContextType<typeof Context>> => {
  const context = useContext(Context);
  if (!context) {
    throw new Error(
      'useRevisionListenerStatus must be used within RevisionListenerStatusProvider.',
    );
  }
  return context;
};

export const useRevisionListenerStatus = () => {
  const { revisionListenerStatus, setRevisionListenerStatus } = _useContext();

  return {
    revisionListenerStatus,
    setRevisionListenerStatus,
  };
};

export const RevisionListenerStatusProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const [revisionListenerStatus, setRevisionListenerStatus] =
    useState<RevisionListenerStatus>('ready');

  return (
    <Context.Provider
      value={{ revisionListenerStatus, setRevisionListenerStatus }}
    >
      {children}
    </Context.Provider>
  );
};
